import React, { useRef, useEffect } from 'react';
const WhatWeDoSection = () => {
  const headshotTileRef = useRef(null);
  const contentRef = useRef(null);
  const anotherElementRef = useRef(null);

  return (
    <section id="what-we-do" className="what-we-do-section" data-scroll-section>
      <div className="headshot-wrapper" data-scroll data-scroll-speed="0.2">
        <div className="headshot-tile" ref={headshotTileRef}>
          <span>Theatrical Headshots</span>
        </div>

        <div className="headshot-description">
          <h3>Why Theatrical Headshots Matter</h3>
          <p>Theatrical headshots aren’t just portraits — they’re a projection of the character you bring into the room. They convey depth, intensity, and story in a single frame.</p>
          <p>These are not smiles-for-the-camera. They are focussed on getting you through the ddoor.  They  convey the  clear sense of who you are as a performer — without a word being spoken.</p>
        </div>
      </div>



      <div
        className="what-we-do-content"
        ref={contentRef}
        data-scroll
        data-scroll-speed="0.5"
      >
        <h2>What We Do</h2>
        <p>Theatrical Headshots, portraits, showreels, town halls, podcasts.</p>
      </div>

      <div
        className="another-element"
        ref={anotherElementRef}
        data-scroll
        data-scroll-speed="0.15"
      >
        <h3>Casting Call Media</h3>
        <p>Showreels are becoming more polished, more cinematic — and more expected. But what if you’re still working toward your first casting call?</p>
        <p>We produce short soliloquies styled to feel like they've been excerpted from larger, established productions — crafted to showcase your range, presence, and voice.</p>
        <p>The result has the impact of a cinematic scene, delivered within a realistic time frame and budget — all built around material you connect with and perform confidently.</p>

      </div>
    </section>
  );
};
export default WhatWeDoSection;